<div class="page-wrapper">
    <div class="overview-container">
        <div class="overview-wrapper">
            <div *ngFor="let ops of opsArray; index as i">
                <app-ops-status-indicator
                    [isReceivingData]="isReceivingData"
                    [index]="i"
                    [ops]="ops"
                ></app-ops-status-indicator>
            </div>
        </div>
    </div>
</div>
